


import { useNavigate } from "react-router-dom";
import { useFetchData } from "./apiHooks";
import { API_ENDPOINTS } from "constants";
import { OBJ } from "constants";

export const useContact = () => {
    const navigate = useNavigate();
    const { saveData, saveError } = useFetchData(API_ENDPOINTS.CUSTOMERS.LIST, null, false);
    const { data, isLoading, error, refetch: search} = useFetchData(API_ENDPOINTS.CUSTOMERS.SEARCH, null, false);
    
    const createContact = async ({firstname, lastname, email, phone, contact_type}) => {
        let newContactId = -1
        let changed_keys = null
        const contactData = { firstname, lastname, email, phone, contact_type, is_verified: true };
        if(email) {
            const contacts = await search({filters: JSON.stringify({email: email.toLowerCase()})})
            if(contacts && contacts.length === 1){
                newContactId = contacts[0].id
            } 
            changed_keys = Object.entries(contactData)
                .filter(([_, value]) => value !== null && value !== undefined)
                .map(([key]) => key);
        }

        const newContact = await saveData({items: [{ id: newContactId, ...contactData, changed_keys,}]})
        return newContactId > 0 ? newContactId : newContact[0].id
    };

    const openContact = (contactId) => {
        navigate(`/admin/${OBJ.CUSTOMERS}/${contactId}`, { replace: false });
    }

    const createAndOpenContact = async (contactId) => {
        const newContact = await createContact(contactId)
        openContact(newContact[0].id)
    }

    return { openContact, createContact, createAndOpenContact, saveError };
};